import React, { useState } from "react";
import {
  Button,
  TextField,
  CircularProgress
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import agent from "../../../../../agent/agent";
import { notification, notificationTypes } from "../../../../../utils/notification";
import getTrans from "../../../../../languages/getTrans";

const AliPayContent = () => {
  const classes = useStyles();
  const history = useHistory();

  const [promoCode, setPromoCode] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);

  const aliPayLink = useSelector((state) => state?.config?.config?.var?.['Ссылка на оплату AliPay'] || 'http://888.mzssh.com/links/F4980C32');
  const handleOpenPayLink = () => {
    const link = window.open(aliPayLink, '_blank', 'noopener,noreferrer');
    if (!link || link.closed || typeof link.closed === 'undefined') {
      const a = document.createElement('a');
      a.href = aliPayLink;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  const handleSendCode = async () => {
    if (!promoCode.trim()) {
      notification({
        message: getTrans('profilePay.aliPay.enterCode'),
        type: notificationTypes.error
      });
      return;
    }
    setIsSubmit(true);
    const response = await agent.post('/api/alipay/check', {
      pass: promoCode
    }).then((res) => {
      return res.data;
    }).catch((err) => {
      return false;
    });
    setIsSubmit(false);
    if (!response) {
      notification({
        message: getTrans('profilePay.aliPay.paymentCodeNotCorrect'),
        type: notificationTypes.error
      });
      return;
    }
    notification({
      message: getTrans('profilePay.aliPay.paymentSuccess'),
      type: notificationTypes.success
    });
    history.push('/balance-history');
  };

  return (
    <div className={classes.root}>
      <div className={classes.instructionText}>
        {getTrans('profilePay.aliPay.instruction')}
      </div>
      <Button
        fullWidth
        variant="contained"
        onClick={handleOpenPayLink}
        className={classes.payButton}
        endIcon={<span>→</span>}
      >
        {getTrans('profilePay.aliPay.registerAndPay')}
      </Button>

      <div className={classes.descriptionText}>
        {getTrans('profilePay.aliPay.enterCodeDescription')}
      </div>
      <div className={classes.inputLabel}>
        {getTrans('profilePay.aliPay.enterCodeLabel')}
      </div>
      <TextField
        fullWidth
        value={promoCode}
        type="text"
        placeholder={getTrans('profilePay.aliPay.placeholderCode')}
        variant="outlined"
        className={classes.textField}
        onChange={(e) => setPromoCode(e.target.value)}
        disabled={isSubmit}
      />

      <Button
        fullWidth
        variant="contained"
        onClick={handleSendCode}
        className={classes.sendButton}
        disabled={isSubmit || !promoCode.trim()}
      >
        {isSubmit ? <CircularProgress size={24} color="inherit" /> : getTrans('profilePay.aliPay.send')}
      </Button>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative'
  },
  instructionText: {
    fontSize: 16,
    color: 'rgba(255, 255, 255, 0.7)',
    marginBottom: '16px',
    lineHeight: '22px',
  },
  payButton: {
    height: '48px',
    background: '#FB7800!important',
    fontSize: 16,
    fontWeight: '500',
    color: 'white!important',
    borderRadius: '8px',
    textTransform: 'none',
    marginBottom: '24px',

    '&:hover': {
      background: '#E86F00!important',
    },

    '& .MuiButton-endIcon': {
      marginLeft: '8px',
      fontSize: '20px',
    },
  },
  descriptionText: {
    fontSize: 16,
    color: 'rgba(255, 255, 255, 0.7)',
    marginBottom: '16px',
    lineHeight: '22px',
  },
  inputLabel: {
    fontSize: 16,
    color: 'rgba(255, 255, 255, 0.7)',
    marginBottom: '8px',
    lineHeight: '22px',
  },
  textField: {
    marginBottom: '16px',

    '& .MuiInputBase-root': {
      background: 'transparent',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '8px',
      height: '48px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-input': {
      color: 'white',
      fontSize: '16px',
      padding: '12px 16px',

      '&::placeholder': {
        opacity: 0.5,
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
    '& .Mui-disabled': {
      background: 'rgba(255, 255, 255, 0.05)',
    },
  },
  sendButton: {
    height: '48px',
    background: '#FB7800!important',
    fontSize: 16,
    fontWeight: '500',
    color: 'white!important',
    borderRadius: '8px',
    textTransform: 'none',

    '&:hover': {
      background: '#E86F00!important',
    },
    '&.Mui-disabled': {
      background: 'rgba(255, 255, 255, 0.1)!important',
      color: 'rgba(255, 255, 255, 0.3)!important',
    },
  },
}));

export default AliPayContent;
